import { z } from 'zod';

/** Converte undefined/null pra string vazia antes da validação. */
export const toEmptyString = (val: unknown) => val ?? '';

/** String obrigatória com preprocess (null/undefined → ''). */
export const requiredString = z.preprocess(
  toEmptyString,
  z.string().min(1, 'Campo obrigatório.')
);
